.controls {
  z-index: 10;
  flex: 0 0 auto;
}

.header {
  background-color: rgba(0, 0, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #eee;
  border-radius: 4px 4px 0 0;
  height: 40px;
}
